import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import applyReducer, { reduceReducers } from './applyReducer';
import mfaConstants from '../constants/mfaConstants';
import loginConstants from '../constants/loginConstants';
const initState = {
  authPin: '',
  error: null,
  secret: '',
  modals: {
    disable: false,
    mfa: false
  }
};
const toggleModal = (state, _ref) => {
  let modalType = _ref.modalType;
  return _objectSpread(_objectSpread({}, state), {}, {
    modals: _objectSpread(_objectSpread({}, state.modals), {}, {
      [modalType]: !state.modals[modalType]
    })
  });
};
const loginSave = (state, _ref2) => {
  let customer = _ref2.customer,
    username = _ref2.username,
    password = _ref2.password;
  return _objectSpread(_objectSpread({}, state), {}, {
    login: {
      customer,
      username,
      password
    },
    modals: _objectSpread(_objectSpread({}, state.modals), {}, {
      mfa: true
    })
  });
};
const loginClear = state => {
  const newState = state;
  delete newState.login;
  return _objectSpread(_objectSpread({}, state), {}, {
    modals: _objectSpread(_objectSpread({}, state.modals), {}, {
      mfa: false
    })
  });
};
const saveSecretSuccess = (state, _ref3) => {
  let pin = _ref3.pin;
  return _objectSpread(_objectSpread({}, state), {}, {
    secret: '',
    authPin: pin,
    modals: {
      disable: false,
      mfa: false
    }
  });
};
const saveSecretFailure = (state, _ref4) => {
  let data = _ref4.data;
  return _objectSpread(_objectSpread({}, state), {}, {
    error: data
  });
};
const destroySuccess = state => _objectSpread(_objectSpread({}, state), {}, {
  modals: {
    disable: false,
    mfa: false
  }
});
const loadSecret = (state, _ref5) => {
  let secret = _ref5.secret;
  return _objectSpread(_objectSpread({}, state), {}, {
    secret
  });
};
const clearError = state => _objectSpread(_objectSpread({}, state), {}, {
  error: null
});
const reducers = {
  [mfaConstants.MFA_MODAL_TOGGLE]: toggleModal,
  [mfaConstants.MFA_SAVE_SUCCESS]: reduceReducers(clearError, saveSecretSuccess),
  [mfaConstants.MFA_SAVE_FAIL]: reduceReducers(clearError, saveSecretFailure),
  [mfaConstants.MFA_DESTROY_SUCCESS]: destroySuccess,
  [mfaConstants.MFA_LOAD_SECRET]: loadSecret,
  [mfaConstants.MFA_LOGIN_SAVE]: loginSave,
  [mfaConstants.MFA_LOGIN_CLEAR]: loginClear,
  [loginConstants.LOGIN_SUCCESS]: loginClear,
  [mfaConstants.MFA_CLEAR_ERROR]: clearError
};
export default applyReducer(reducers, initState);